import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

export const initAlpine = () => {
  
  window.Alpine = Alpine

	Alpine.store('nav', {
		isNavOpen: false,
		toggleNav() {
			this.isNavOpen = !this.isNavOpen
		},
		openNav() {
			this.isNavOpen = true
		},
		closeNav() {
			this.isNavOpen = false
		}
	})

	Alpine.plugin(collapse)
  Alpine.start()

}